import moment from 'moment';



export const updatePlanningRecords = (
  planningRecords: any[],
  productionDataByPart: Record<string, any>,
) => {
  let index = 0;
  const modifiedPlanningRecords: any[] = planningRecords.map(r => ({ ...r }));

  for (const planningRecord of planningRecords) {
    const jobNumber = planningRecord.job_number;
    const partData = productionDataByPart[jobNumber] || {};
    const shiftWorkingMinutes = partData.shiftWorkingMinutes;

    // Auto-fill start date/time from previous row when missing
    if ((!planningRecord.start_date || !planningRecord.start_time) && index > 0) {
      const prev = modifiedPlanningRecords[index - 1];
      if (prev) {
        // prefer actual completion, fallback to predicted completion
        const sourceDate =
          prev.actual_completion_date ?? prev.predicted_completion_date;
        const sourceTime =
          prev.actual_completion_time ?? prev.predicted_completion_time;

        if (!planningRecord.start_date && sourceDate) {
          planningRecord.start_date = sourceDate;
        }
        if (!planningRecord.start_time && sourceTime) {
          planningRecord.start_time = sourceTime;
        }
      }
    }

    // Retrieve stroke rate
    const strokeRate = planningRecord.strokeRate;

    // Calculate required values
    const {
      totalTimeRequired,
      jobCompletion,
      predictedCompletionDate,
      actualQty,
    } = calculateCompletionData(
      planningRecord,
      partData,
      strokeRate,
      shiftWorkingMinutes,
    );

    const totalDownTime = calculateTotalDownTime(partData);

    // Calculate predicted completion time (uses shiftWorkingMinutes too)
    const predictedCompletionTime = calculateCompletionTime(
      totalTimeRequired,
      planningRecord.start_time,
      totalDownTime,
      shiftWorkingMinutes,
    );

    // -------------- NEW: auto-insert actual completion when jobCompletion === 100 --------------
    // If job is complete and actual completion values are missing, set them to now
    const willInsertActualNow = jobCompletion === 100;
    const prevEntry = modifiedPlanningRecords[index] || {};
    let actualCompletionDateToSet = prevEntry.actual_completion_date ?? null;
    let actualCompletionTimeToSet = prevEntry.actual_completion_time ?? null;

    if (willInsertActualNow) {
      // Only set if not already present
      if (!actualCompletionDateToSet) {
        actualCompletionDateToSet = moment().toDate();
      }
      if (!actualCompletionTimeToSet) {
        actualCompletionTimeToSet = moment().toDate();
      }
    }
    // -------------------------------------------------------------------------------------------

    // Update the plan in the copied array
    const updatedCurrent = {
      ...modifiedPlanningRecords[index],
      actual_qty: actualQty || 0,
      stroke: strokeRate?.stroke || 0,
      stroke_id: strokeRate?._id || null,
      total_time_required: totalTimeRequired || 0,
      total_downtime: totalDownTime || 0,
      job_completion: jobCompletion,
      records: partData.records || [],
      predicted_completion_date: predictedCompletionDate || null,
      predicted_completion_time: predictedCompletionTime || null,
      // actual completion fields: preserve existing values unless we auto-inserted now
      actual_completion_date:
        actualCompletionDateToSet ??
        modifiedPlanningRecords[index]?.actual_completion_date ??
        null,
      actual_completion_time:
        actualCompletionTimeToSet ??
        modifiedPlanningRecords[index]?.actual_completion_time ??
        null,
    };

    modifiedPlanningRecords[index] = updatedCurrent;

    // ------------------ NEW: propagate previous completion to next row's start ------------------
    // Always update the NEXT row start_date / start_time to follow this row's completion.
    // Preference: actual_completion_* if present, otherwise predicted_completion_*.
    const nextIndex = index + 1;
    if (nextIndex < modifiedPlanningRecords.length) {
      const nextRow = { ...modifiedPlanningRecords[nextIndex] };

      const sourceStartDate =
        updatedCurrent.actual_completion_date ?? updatedCurrent.predicted_completion_date;
      const sourceStartTime =
        updatedCurrent.actual_completion_time ?? updatedCurrent.predicted_completion_time;

      // If a source is available, overwrite next row start values (user requested always update)
      if (sourceStartDate) {
        nextRow.start_date = sourceStartDate;
      }
      if (sourceStartTime) {
        nextRow.start_time = sourceStartTime;
      }

      modifiedPlanningRecords[nextIndex] = nextRow;
    }
    // ------------------------------------------------------------------------------------------

    index++;
  }
  return modifiedPlanningRecords;
};


// export const updatePlanningRecords = (
//   planningRecords: any[],
//   productionDataByPart: Record<string, any>,
// ) => {
//   let index = 0;
//   const modifiedPlanningRecords: any[] = [...planningRecords];
//
//   for (const planningRecord of planningRecords) {
//     const jobNumber = planningRecord.job_number;
//     const partData = productionDataByPart[jobNumber] || {};
//     const shiftWorkingMinutes = partData.shiftWorkingMinutes;
//
//     // Auto-fill start date/time from previous row when missing
//     if ((!planningRecord.start_date || !planningRecord.start_time) && index > 0) {
//       const prev = modifiedPlanningRecords[index - 1];
//       if (prev) {
//         // prefer actual completion, fallback to predicted completion
//         const sourceDate =
//           prev.actual_completion_date ?? prev.predicted_completion_date;
//         const sourceTime =
//           prev.actual_completion_time ?? prev.predicted_completion_time;
//
//         if (!planningRecord.start_date && sourceDate) {
//           planningRecord.start_date = sourceDate;
//         }
//         if (!planningRecord.start_time && sourceTime) {
//           planningRecord.start_time = sourceTime;
//         }
//       }
//     }
//
//     // Retrieve stroke rate
//     const strokeRate = planningRecord.strokeRate;
//
//     // Calculate required values
//     const {
//       totalTimeRequired,
//       jobCompletion,
//       predictedCompletionDate,
//       actualQty,
//     } = calculateCompletionData(
//       planningRecord,
//       partData,
//       strokeRate,
//       shiftWorkingMinutes,
//     );
//
//     const totalDownTime = calculateTotalDownTime(partData);
//
//     // Calculate predicted completion time (uses shiftWorkingMinutes too)
//     const predictedCompletionTime = calculateCompletionTime(
//       totalTimeRequired,
//       planningRecord.start_time,
//       totalDownTime,
//       shiftWorkingMinutes,
//     );
//
//     // -------------- NEW: auto-insert actual completion when jobCompletion === 100 --------------
//     // If job is complete and actual completion values are missing, set them to now
//     const willInsertActualNow = jobCompletion === 100;
//     const prevEntry = modifiedPlanningRecords[index] || {};
//     let actualCompletionDateToSet = prevEntry.actual_completion_date ?? null;
//     let actualCompletionTimeToSet = prevEntry.actual_completion_time ?? null;
//
//     if (willInsertActualNow) {
//       // Only set if not already present
//       if (!actualCompletionDateToSet) {
//         actualCompletionDateToSet = moment().toDate();
//       }
//       if (!actualCompletionTimeToSet) {
//         actualCompletionTimeToSet = moment().toDate();
//       }
//     }
//     // -------------------------------------------------------------------------------------------
//
//     // Update the plan in the copied array
//     modifiedPlanningRecords[index] = {
//       ...modifiedPlanningRecords[index],
//       actual_qty: actualQty || 0,
//       stroke: strokeRate?.stroke || 0,
//       stroke_id: strokeRate?._id || null,
//       total_time_required: totalTimeRequired || 0,
//       total_downtime: totalDownTime || 0,
//       job_completion: jobCompletion,
//       records: partData.records || [],
//       predicted_completion_date: predictedCompletionDate || null,
//       predicted_completion_time: predictedCompletionTime || null,
//       // actual completion fields: preserve existing values unless we auto-inserted now
//       actual_completion_date: actualCompletionDateToSet ?? modifiedPlanningRecords[index]?.actual_completion_date ?? null,
//       actual_completion_time: actualCompletionTimeToSet ?? modifiedPlanningRecords[index]?.actual_completion_time ?? null,
//     };
//
//     index++;
//   }
//   return modifiedPlanningRecords;
// };

const calculateTotalDownTime = (partData: any) => {
  // Expect partData.totalDowntime in minutes or falsy
  const totalDownTime = partData?.totalDowntime ?? 0;
  return totalDownTime;
};

// Helper function to calculate completion data
const calculateCompletionData = (
  planningRecord: any,
  partData: any,
  strokeRate: any,
  shiftWorkingMinutes?: number,
) => {
  let totalTimeRequired = 0;
  let jobCompletion = 0;
  let predictedCompletionDate: Date | null = null;
  let actualQty = 0;

  if (strokeRate && planningRecord.planned_qty > 0) {
    actualQty = partData.actualQty ?? 0;

    if (strokeRate.stroke) {
      // keep previous behavior: integer division (parseInt)
      totalTimeRequired = parseInt(
        planningRecord.planned_qty / strokeRate.stroke + '',
        10,
      );
    }

    if (actualQty >= 0 && planningRecord.planned_qty >= 0) {
      jobCompletion = parseInt(
        ((actualQty / planningRecord.planned_qty) * 100).toFixed(2),
        10,
      );
    }

    if (totalTimeRequired >= 0 && planningRecord.start_date) {
      const startDate = new Date(planningRecord.start_date);

      if (shiftWorkingMinutes && shiftWorkingMinutes > 0) {
        const fullShiftDays = Math.floor(totalTimeRequired / shiftWorkingMinutes);
        // predictedCompletionDate uses full shift-days added to start_date
        predictedCompletionDate = new Date(
          startDate.getTime() + fullShiftDays * 24 * 60 * 60 * 1000,
        );
      } else {
        // fallback: use minutes to compute a date directly (rare)
        const totalTimeInMs = totalTimeRequired * 60 * 1000;
        predictedCompletionDate = new Date(startDate.getTime() + totalTimeInMs);
      }
    }
  }

  return {
    totalTimeRequired,
    jobCompletion,
    predictedCompletionDate,
    actualQty,
  };
};

const calculateCompletionTime = (
  totalTimeRequired: any,
  startTime: any,
  totalDowntime: any,
  shiftWorkingMinutes?: number,
) => {
  if (!totalTimeRequired || !startTime) {
    return null;
  }

  const downtimeMinutes = parseInt(totalDowntime, 10) || 0;
  const parsedTotalTimeRequired = parseInt(totalTimeRequired, 10) || 0;

  if (shiftWorkingMinutes && shiftWorkingMinutes > 0) {
    const fullShiftDays = Math.floor(parsedTotalTimeRequired / shiftWorkingMinutes);
    const remainingMinutes = parsedTotalTimeRequired % shiftWorkingMinutes;

    // Start from startTime moment, add fullShiftDays as calendar days
    const startMoment = moment(startTime).add(fullShiftDays, 'days');
    const predictedCompletionMoment = startMoment.add(remainingMinutes + downtimeMinutes, 'minutes');

    return predictedCompletionMoment.toDate();
  } else {
    // Fallback: add totalTimeRequired + downtime in minutes
    const totalTime = parsedTotalTimeRequired + downtimeMinutes;
    const startMoment = moment(startTime);
    const predictedCompletionTime = startMoment.add(totalTime, 'minutes');
    return predictedCompletionTime.toDate();
  }
};


